class OrderClaim {
  constructor() {
    this.storeUrl=window.location.origin;
    this.storeName=Shopify.shop;
    this.init();
  }
  formSubmitEvent = () => {
    $(document).on('submit','.order-claim-page-wrap .order-claim-form',async (e)=>{
      e.preventDefault();
      $('.incorrect-value-order').hide();
      let that = e.currentTarget;
      $('.submit-button').addClass('loading');
      let actionUrl = `${this.storeUrl}/apps/simplyinsurance/storefront-api/getOrderfulfilmentdata`;
      let formSerialize = $(that).serializeArray();
      let passObj = {};
      formSerialize.map((i)=>{
        passObj[i.name]=i.value;
      })
      let respo = await fetch(actionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'shopname':this.storeName
        },
        body: JSON.stringify(passObj)
      })
      respo = await respo.json();
      if(respo.status == 0){
        window.location.href=`/pages/manage-claim-requests-user?token=${respo.token}`;
      }else{
        $('.submit-button').removeClass('loading');
        $('.incorrect-value-order').text(respo.message).show();
      }
    });
  }
  clickEvent = () => {
    $(document).on('click','.cancel-button',(e)=>{
      window.location.href = '/';
    })
  }
  init = () => {
    this.formSubmitEvent();
    this.clickEvent();
  }
}
class ManageClaimRequests {
  constructor() {
    this.storeUrl=window.location.origin;
    this.storeName=Shopify.shop;
    this.queryString = window.location.search;
    this.language = simplyInsurance.language;
    this.images=[];
    this.customer_email = '';
    this.pageContent = '';
    this.init();
  }
  getUrlVars = () => {
    let vars = [], hash;
    let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
      hash = hashes[i].split('=');
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
  }
  setupData = () => {
    if(!this.pageContent){
      return false;
    }
    $('.top-section').show();
    let data = this.pageContent;
    let finalHtml = '';
    $('.order-wrap-text').text(data.order_name);
    $('.order-name-text').text(data.customer_name);
    $('.order-email-text').text(data.email);
    this.customer_email = data.email;
    $('.order-status-text .badge-order-status').text(data.fulfillment_status);
    const date = new Date(data.order_created_at);
    $('.order-placed-text').text(date.toDateString ());
    $('.order-status-text').text(data.fulfillment_status );
    
    data.fulfillments.map((item,index)=>{
      let itemsHtml = '';
      item.line_items.map((i,j)=>{
        let currency_code = i.price_set.shop_money.currency_code;
        let html = 
        `<tr>
          <td>${i.title}</td>
          <td><span class="currency-code">${currency_code}</span> ${i.price_set.shop_money.amount} x ${i.quantity}</td>
          <td><span class="currency-code">${currency_code}</span> ${i.price_set.shop_money.amount * i.quantity}</td>
        </tr>`;
        itemsHtml += html;
      });
      this.shopify_order_id = item.shopify_order_id;
      let fulfillHtml = `<div class="bottom-section-inner" data-fulfilment_id="${item.fulfilment_id}">
        <div class="tracking-section">
          <div class="tracking-heading">
            <h2 class="tracking-heading-inner">${this.language.fulfilled} (${item.line_items.length}) <span class="order-number">${item.fulfilment_name}</span></h2>
          </div>
          <div class="order-tracking-wrap">
            Other tracking
            <a class="order-tracking-url" href="${item.tracking_url}">
              <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true"><path d="M13 12a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H6c-.575 0-1-.484-1-1V7a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2v5h5a1 1 0 0 1 1-1zm-2-7h4v4a1 1 0 1 1-2 0v-.586l-2.293 2.293a.999.999 0 1 1-1.414-1.414L11.586 7H11a1 1 0 0 1 0-2z"></path></svg>
            </a>
          </div>
        </div>
        <div class="order-items-section">
          <div class="claim-status-wrap">
            ${this.language.claim_status}<span class="badge-requested ${item.claim_status ? "requested" : ''}">${item.claim_status ? item.claim_status : this.language.not_requested}</span>
          </div>
          <table>
            <thead>
              <tr>
                <th>${this.language.item}</th>
                <th>${this.language.price}</th>
                <th>${this.language.total}</th>
              </tr>
            </thead>
            <tbody>
              ${itemsHtml}
            </tbody>
          </table>
        </div>
        <div class="generate-claim-section">
          <button class="generate-claim-button"${item.claim_status ? "disabled" : ''}>${this.language.genearate_claim_request}</button>
        </div>
      </div>`;
      finalHtml += fulfillHtml;
    });
    $('.manage-claim-request-wrap .bottom-section').html(finalHtml);
  }
  getOrderDetails = async () => {
    let token = this.getUrlVars()["token"];
    if(!token){
      return false;
    }
    let actionUrl = `${this.storeUrl}/apps/simplyinsurance/storefront-api/getOrderfulfilmentFront?requested_token=${token}`;
    let respo = await fetch(actionUrl, {
      method: 'GET',
      headers: {
        'shopname':this.storeName
      }
    })
    respo = await respo.json();
    if(respo.status == 0){
      this.pageContent = respo.data;
      this.setupData();
    }
  }
  changeEvent = () => {
    $(document).on('change','#upload-file',async (e)=>{
      $('.customer-note-issue').hide();
      $('.submit-claim-button').prop('disabled', true);
      let that = e.currentTarget;
      let images = new FormData();
      for(let i=0; i < that.files.length; i++){
        images.append("file[]", that.files[i]);
      }
      const instance = axios.create({
          baseURL: "https://simplyinsurance.lucentinnovation.com",
          headers: { 'Content-Type': 'application/json'}  
      });
      let url = `${this.storeUrl}/apps/simplyinsurance/storefront-api/handleimages`;
      instance
      .post(url, images, {headers: {
            "Content-type": "multipart/form-data",
            'shopname':this.storeName
          }})
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.status === 0) {
            that.images= response.data.image_url;
            $('.submit-claim-button').prop('disabled', false);
          } else {
            console.log('error');
          }
        }
      });
    });
  }
  clickEvents = () => {
    $(document).on('click','.custom-popup-wrap .close-btn',(e)=>{
      $('.custom-popup-wrap').hide();
      $('body').removeClass('overflow-hidden');
    });
    $(document).on('click','.generate-claim-button',(e)=>{
      debugger
      let that = e.currentTarget;
      let parent = $(that).parents('.bottom-section-inner');
      this.fulfilment_id = parent.data('fulfilment_id');
      $('.custom-popup-wrap').show();
      $('body').addClass('overflow-hidden');
    });
    $(document).on('click','.submit-claim-button',async(e)=>{
      debugger
      let that = e.currentTarget;
      $(that).addClass('loading');
      $('.customer-note-issue').hide();
      let note = $('.customer-note-section .textarea-wrap').val();
      if(note.length == 0){
        $('.customer-note-issue').show();
        $(that).removeClass('loading');
        return false;
      }
      let fulfilment_id = this.fulfilment_id;
      let shopify_order_id = this.shopify_order_id;
      let images = this.images.join(',');
      let passObj = {
        claim_images: images,
        customer_email: this.customer_email,
        customer_note: note,
        fulfilment_id: fulfilment_id,
        shopify_order_id: shopify_order_id
      }
      let actionUrl = `${this.storeUrl}/apps/simplyinsurance/storefront-api/getInsuranceclaimrequests`;
      let respo = await fetch(actionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'shopname':this.storeName
        },
        body: JSON.stringify(passObj)
      })
      respo = await respo.json();
      if(respo.status == 0){
        location.reload();
      }else{
        console.log('error');
      }
    });
  }
  init = () => {
    this.getOrderDetails();
    this.changeEvent();
    this.clickEvents();
  }
}
new ManageClaimRequests;
new OrderClaim;
